import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import './App.css';
import About from './components/About';
import BlogDetail from './components/BlogDetail';
import Blogs from './components/Blogs';
import ClientReview from './components/ClientReview';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Landing from './components/Landing';
import Navbar from './components/Navbar';
import ProjectDetail from './components/ProjectDetail';
import Projects from './components/Projects';
import Technologies from './components/Technologies';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import Loader from './components/loader';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== '/') {
      window.scrollTo(0, 0);
      if (window.lenis) {
        window.lenis.scrollTo(0, { immediate: true });
      }
    }
  }, [pathname]);

  return null;
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize Lenis exactly once on mount
    const lenis = new Lenis({
      autoRaf: true,
    });

    window.lenis = lenis;

    return () => {
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  useEffect(() => {
    // Loader timer
    const timer = setTimeout(() => {
      setLoading(false);
    }, 4000);
  
    return () => {
      clearTimeout(timer);
    };
  }, []);
  
  return (
    <Router>
      <ScrollToTop />
      {/* Loader logic for first visit: hide site until loading is done */}
      {loading ? (
        <Loader />
      ) : (
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Landing />
                <Projects />
                <Technologies />
                <ClientReview />
                <Blogs />
                <About />
                <Contact />
              </>
            } />
            <Route path="/project/:projectId" element={<ProjectDetail />} />
            <Route path="/blog/:blogId" element={<BlogDetail />} />
          </Routes>
          <Footer />
        </div>
      )}
    </Router>
  );
}

export default App;

